
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { _user, _handler } from "../classes/index.classes";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { CustomDialog } from "../classes/index.classes";
import { init } from "../components/drawer";
import { Toasted, Countdown } from "../classes/index.classes";

let partyDrawerHTML = `<div id="party-drawer" class="bg-body rounded-start  mt-0 mt-md-18 mt-lg-20" data-kt-drawer-name="party" data-kt-drawer-activate="true" data-kt-drawer-overlay="false" data-kt-drawer-width="{default:'300px', 'md': '350px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle=".party-drawer-toggle" data-kt-drawer-close=".party-drawer-close" data-kt-drawer-escape="true" style="">

        <!--begin::Messenger-->
        <div class="card w-100 rounded-0 border-0" id="#party-drawer-container">
            <!--begin::Card header-->
            <div class="card-header pe-5 border-bottom-0" id="party-card-header">
                <!--begin::Title-->
                <div class="card-title">
                    <h3 class="card-title fw-bolder text-gray-700 party-party-name">Party</h3>
                </div>
                <!--end::Title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">                    
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-active-light-primary party-drawer-close">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->
            <div class="card-body" id="party-card-body">
                <div class="fs-8 fw-bold mb-1">
                    <span class="text-gray-600" data-i18n="party.ratingav"></span><span class="text-primary ms-1 party-party-rating fs-6 text-white">0</span>
                </div>
                <div class="d-flex flex-row w-100 align-items-center justify-content-between gap-1 party-party-members px-4 py-3 bg-gray-100 rounded mb-2">
                    <div class="symbol symbol-50px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-50px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-50px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-50px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-50px border-1 border-primary">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-users-crown fs-2 text-primary"></i>
                        </span>
                    </div>
                </div>
                <div class="d-flex flex-row w-100 align-items-center justify-content-between">
                    <span class="align-self-end btn btn-icon btn-sm btn-icon-gray-700 btn-text-gray-700 btn-active-light btn-active-color-gray-900 party-edit-party-name owner-only" data-i18n="[title]party.partyname" data-toggle="tooltip">
                        <i class="fas fa-edit fs-4 btn-icon-color-danger btn-active-color-gray-200"></i>
                    </span>
                    <span class="align-self-end btn btn-sm btn-icon-danger btn-text-danger btn-active-danger btn-active-color-gray-200 party-party-leave">
                        <i class="fas fa-sign-out-alt fs-4 btn-icon-color-danger btn-active-color-gray-200"></i><span class="fw-bolder party-party-leave-label" data-i18n="party.leave">Leave</span>
                    </span>
                </div>
            </div>

            <div class="card-body pt-0 pb-2 h-100" id="party-chat-body">
                <div id="party-chat-container" class="bg-gray-100 rounded px-4 py-3 overflow-auto" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#party-card-header,#party-card-body,#party-card-footer" data-kt-scroll-wrappers="#party-chat-body,#party-drawer-container,#party-drawer" data-kt-scroll-offset="1px">
                </div>
            </div>
            <div class="card-footer pt-4 pb-2 border-0" id="party-card-footer">
                <div class="input-group input-group-solid">
                    <textarea id="party-chat-input" class="form-control me-4 fw-normal fs-7" rows="1" data-kt-element="input" placeholder="Type a message" style="resize:none;height: 43px;" data-i18n="[placeholder]party.chatplaceholder"></textarea>
                    <button id="btn-send-party-chat" class="btn btn-icon btn-light-primary btn-active-light-primary" type="button" data-kt-element="send"><i class="bi bi-send fs-4"></i></button>
                </div>
                <label class="fs-8 fw-bolder party-chat-input-limiter">0/100</label>
            </div>
        </div>          
    </div>
`;


let partyToolbarHtml = `
    <div class="d-flex align-items-center flex-wrap gap-1 cursor-pointer party-init z-index-3" data-toggle="tooltip" title="Create Party">
                <div class="symbol-group symbol-hover flex-nowrap flex-row-reverse party-toolbar">
                    <div class="symbol symbol-35px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-35px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-35px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-35px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                    <div class="symbol symbol-35px border-1 border-primary">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-users-crown fs-2 text-primary"></i>
                        </span>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light btn-active-color-primary party-tooblar-btn"><i class="far fa-plus-circle fs-2"></i></button>
                </div>
            </div>
`;

let sendingMsg = false;
let onLeaving = false;
let onCreating = false;
let partyDrawer = null;
let showingList = false;

var initPartySystem = async () => {

    return;
    // Party system logic

    initPartyDrawer();
    let res = await KTAPI.getMyParty();
    if (res.message == 'error') {
        console.log('Error al cargar el party');
        return;
    }
    if (res.message == 'done') {
        renderPartyToolbar(res.party);
        renderPartyDrawer(res.party);
        if(res.party != null)
        {
            KTAPI.getPartyChatHistory({partyId: res.party._id}).then(ch => {
                if(ch.message == 'error') {
                    console.log('Error al cargar el chat');
                }
                if(ch.message == 'done') {
                    renderPartyChat(ch.chatMessages);
                }
            })
            .catch(error => {
                console.error('Error al procesar la solicitud', error);
            });
        }
    }
    initHandlers();
    
    // console.log('Party system initialized');
}

function renderPartyToolbar(data) {
    if(data == null) {
        $(".party-toolbar-container").html(partyToolbarHtml);
        $('[data-toggle="tooltip"]').tooltip();
    }
    else{

        let partyOwner = `
            <div class="position-relative symbol symbol-35px border-1 border-primary ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.ownerId}">
                <i class="fas fa-crown fs-7 text-zyellow position-absolute ms-auto me-auto start-0 end-0 text-center" style="top:-6px"></i>
                <img src="${data.membersInfo[data.ownerId].avatar === undefined ? "assets/media/avatars/default.jpg" : data.membersInfo[data.ownerId].avatar}" class="" alt="">
            </div>
        `;

        let partyMembers = '';

        //for(let i = 0; i < data.maxMembers; i++) {
        for(let i = data.maxMembers - 1; i >= 0; i--) {
            if(data.members[i] == data.ownerId) continue;
            if(data.members[i] != null && data.members[i] != undefined) {
                partyMembers += `
                    <div class="position-relative symbol symbol-35px border-1 border-primary ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.members[i]}">
                        <img src="${data.membersInfo[data.members[i]].avatar === undefined ? "assets/media/avatars/default.jpg" : data.membersInfo[data.members[i]].avatar}" class="" alt="">
                    </div>
                `;
            }
            else {
                partyMembers += `
                    <div class="symbol symbol-35px border-1 border-gray-400">
                        <span class="symbol-label bg-gray-200">
                            <i class="far fa-user-plus fs-4"></i>
                        </span>
                    </div>
                `;
            }
        }

           

        let partyToolbarHtml = `
            <div class="d-flex align-items-center flex-wrap gap-1 cursor-pointer z-index-3 party-drawer-toggle" partyid="${data._id}" data-toggle="tooltip" title="${data.partyName}">
                <div class="symbol-group symbol-hover flex-nowrap flex-row-reverse party-toolbar">
                    ${partyMembers}
                    ${partyOwner}
                </div>
                <div class="d-flex align-items-center">
                    <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light btn-active-color-primary party-tooblar-btn"><i class="far fa-plus-circle fs-2"></i></button>
                </div>
            </div>
        `;
        $(".party-toolbar-container").html(partyToolbarHtml);
        $('[data-toggle="tooltip"]').tooltip();
    }
    console.log(data);
}

function initHandlers() {
    
    $(".party-init").off("click");
    $(".party-init").on("click", async function() {
        if(onCreating) return;
        onCreating = true;
        let res = await KTAPI.createParty();        
        //console.log('Party system clicked');
        onCreating = false;
        if(res.message == 'error') {
            
        }
        else
        {            
            /*renderPartyToolbar(res.party);
            renderPartyDrawer(res.party);
            const $temp = $(`<div data-i18n="party.partycreated"></div>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showSuccess(sanitizedHTML);*/
            partyDrawer.show();
            
        }

    });



    $("#party-chat-input").off("input");
    $("#party-chat-input").on("input", function() {
        let len = $(this).val().length;
        $(".party-chat-input-limiter").text(`${len}/100`);
        if(len > 100) {
            $(".party-chat-input-limiter").addClass("text-danger");
        }
        else {
            $(".party-chat-input-limiter").removeClass("text-danger");
        }        
    });

    $("#btn-send-party-chat").off("click");
    $("#btn-send-party-chat").on("click", async function() {
        let msg = $("#party-chat-input").val();
        msg.trim();
        if(msg.length == 0 || msg.length > 100) {
            return;
        }
        
        await sendPartyChatMessage(msg);
        $("#party-chat-input").val('');
        $(".party-chat-input-limiter").text('0/100');
        
    });
    
    $("#party-chat-input").off("keypress");
    $("#party-chat-input").on("keypress", async function(e) {
        
        if (e.keyCode == 27)
        {
            e.preventDefault();
        }

        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            let message = $("#party-chat-input").val();
            message = message.trim();
            if(message.length > 0 && message.length < 100)
            {
                console.log('Mensaje length: ' + message.length);
                
                sendPartyChatMessage(message);
                $("#party-chat-input").val("");
                $(".party-chat-input-limiter").text('0/100');
                
            }
        }
        
    });

    $(".party-party-leave").off("click");
    $(".party-party-leave").on("click", async function(e) {
        /*let res = await KTAPI.leaveParty();
        if(res.message == 'error') {
            console.log('Error al dejar el party');
        }
        if(res.message == 'done') {
            renderPartyToolbar(null);
        }*/
        e.preventDefault();
        let leave = await leaveDlg();
        if(leave == 1) {
            //alert('Dejar el party');
            let res = await KTAPI.leaveParty();
            console.log(res);
            if(res.message == 'error') {
                //console.log('Error al dejar el party');
                if(res.error !== undefined) {
                    errorDlg(res.error);
                }
            }
            if(res.message == 'done') {
                //renderPartyToolbar(null);
            }
        }
    });      
    
    $(document).off("click", ".party-party-invite-list");
    $(document).on("click", ".party-party-invite-list", async function() {        
        //console.log('Invitar a alguien');
        //let res = await KTAPI.getPartyFriendsForInvite();
        //console.log(res);
        //if(res.message == 'error') {
        //    console.log('Error al cargar la lista de amigos');
        //}
        //if(res.message == 'done') {
        //    invitationListDlg(res.friends);            
        //}
        invitationListDlg(null);
    });

    $(document).off("click", ".party-invite-friend");
    $(document).on("click", ".party-invite-friend", async function() {
        let steamid = $(this).attr("steamid");
        let res = await KTAPI.inviteToParty({recipientId: steamid});
        if(res.message == 'error') {
            console.log('Error al invitar a alguien');
        }
        if(res.message == 'done') {
            console.log('Invitación enviada');
            $(`.party-invitation-state[steamid="${steamid}"]`).html(`<button class="btn btn-sm btn-icon btn-color-info" steamid="${steamid}"><span class="spinner-border spinner-border-sm align-middle border-3 h-20px w-20px"></span></button>`);
            $(`.party-invitation-state-label[steamid="${steamid}"]`).attr("data-i18n", "party.oninvite").localize();
        }
    });

    $(document).off("click", ".party-accept-invitation");
    $(document).on("click", ".party-accept-invitation", async function() {
        //encuentra el id de la invitación dentro de las clases del elemento actual que empieza con id-
        let invitationId = $(this).attr("class").split(" ").find((c) => c.startsWith("invitation-")).split("-")[1];        
        let res = await KTAPI.acceptInvite({invitationId: invitationId});
        if(res.message == 'error') {
            console.log('Error al aceptar la invitación', res.error);
        }
        if(res.message == 'done') {
            console.log('Invitación aceptada');
            //renderPartyToolbar(res.party);
            //renderPartyDrawer(res.party);
            /*const $temp = $(`<div data-i18n="party.invitationaccepted"></div>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showSuccess(sanitizedHTML);*/
            partyDrawer.show();
        }
    });

    $(document).off("click", ".party-decline-invitation");
    $(document).on("click", ".party-decline-invitation", async function() {
        let invitationId = $(this).attr("class").split(" ").find((c) => c.startsWith("invitation-")).split("-")[1];
        let res = await KTAPI.declineInvite({invitationId: invitationId});
        if(res.message == 'error') {
            console.log('Error al declinar la invitación');
        }
        if(res.message == 'done') {
            console.log('Invitación declinada');
        }
    });

    $(document).off("click", ".party-edit-party-name");
    $(document).on("click", ".party-edit-party-name", async function() {
        let partyName = await editPartyNameDlg();
        if(partyName == 1) {
            
        }   
             
    });   
    
    $(document).off("click", ".party-kick-member");
    $(document).on("click", ".party-kick-member", async function() {
        let steamid = $(this).attr("steamid");
        let res = await KTAPI.kickParty({targetId: steamid});
        if(res.message == 'error') {
            console.log('Error al expulsar al usuario', res.error);

        }
        if(res.message == 'done') {
            console.log('Usuario expulsado');
        }
    });
}

const partySocket = (socket) => {
    socket.on("user-connected", async (data) => {
        
    });

    socket.on("user-disconnected", async (data) => {
               
    });

    socket.on("party_chat", async (data) => {
       //console.log('Mensaje de chat recibido', data);
       renderPartyChat([data]);       
    });

    socket.on("party_created", async (data) => {
        //console.log('Party creado', data);
        renderPartyToolbar(data);
        renderPartyDrawer(data);
        const $temp = $(`<div data-i18n="party.partycreated"></div>`);
        $temp.localize();
        const sanitizedHTML = $temp.text();
        Toasted.showSuccess(sanitizedHTML);
        
    });
    
    socket.on("party_joined", async (data) => {
        console.log('Party joined', data);
        renderPartyToolbar(data);
        renderPartyDrawer(data);
        if(data.whoJoined == _user.me.steamid) {
            const $temp = $(`<div data-i18n="party.partyjoined"></div>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showSuccess(sanitizedHTML);
        }
    })

    socket.on("party_left", async (data) => {
        console.log('Party left', data);
        if(data.whoLeft == _user.me.steamid) {
        
            partyDrawer.hide();
            renderPartyToolbar(null);                                                                                      
            renderPartyDrawer(null);
            const $temp = $(`<div data-i18n="party.partyleft"></div>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showSuccess(sanitizedHTML);
        }
        else
        {
            renderPartyToolbar(data);                                                                                      
            renderPartyDrawer(data);
        }
    });

    socket.on("party_kicked", async (data) => {
        console.log('party_kicked', data);
        if(data.whoWasKicked == _user.me.steamid) {
            partyDrawer.hide();
            renderPartyToolbar(null);                                                                                      
            renderPartyDrawer(null);
            const $temp = $(`<div data-i18n="party.partykicked"></div>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showWarning(sanitizedHTML);
        }
        else
        {
            renderPartyToolbar(data);                                                                                      
            renderPartyDrawer(data);
        }
    });

    socket.on("party_invitation", async (data) => {
        console.log('Invitación de party', data);
        invitationDlg(data);        
    });

    socket.on("party_invitation_expired", async (data) => { 
        console.log('Invitación expirada', data);
        $(`.party-invitation-state[steamid="${data.invitationId.recipientId}"]`).html(`<button class="btn btn-sm btn-icon btn-color-primary btn-active-color-primary party-invite-friend" steamid="${data.invitationId.recipientId}"><i class="fas fa-plus-circle fs-2"></i></button>`);
        $(`.party-invitation-state-label[steamid="${data.invitationId.recipientId}"]`).attr("data-i18n", "").text("");
    });

    socket.on("party_invitation_accepted", async (data) => {
        console.log('party_invitation_accepted', data);
        $(`.party-invitation-container[steamid="${data.invitationId.recipientId}"]`).addClass("opacity-50");
        $(`.party-invitation-state[steamid="${data.invitationId.recipientId}"]`).html(`<button class="btn btn-sm btn-icon btn-color-primary btn-active-color-primary disabled" steamid="${data.invitationId.recipientId}"><i class="fas fa-plus-circle fs-2"></i></button>`);
        $(`.party-invitation-state-label[steamid="${data.invitationId.recipientId}"]`).attr("data-i18n", "party.inparty").localize();
    });

    socket.on("party_invitation_declined", async (data) => {
        console.log('party_invitation_declined', data);
        $(`.party-invitation-container[steamid="${data.invitationId.recipientId}"]`).removeClass("opacity-50");
        $(`.party-invitation-state[steamid="${data.invitationId.recipientId}"]`).html(`<button class="btn btn-sm btn-icon btn-color-primary btn-active-color-primary party-invite-friend" steamid="${data.invitationId.recipientId}"><i class="fas fa-plus-circle fs-2"></i></button>`);
        $(`.party-invitation-state-label[steamid="${data.invitationId.recipientId}"]`).attr("data-i18n", "").text("");
    });

    socket.on("party_user_state_free", async (data) => {
        console.log('party_user_state_free', data);
        if(data.whoWasKicked !== undefined) data.whoLeft = data.whoWasKicked;
        $(`.party-invitation-container[steamid="${data.whoLeft}"]`).removeClass("opacity-50");
        $(`.party-invitation-state[steamid="${data.whoLeft}"]`).html(`<button class="btn btn-sm btn-icon btn-color-primary btn-active-color-primary party-invite-friend" steamid="${data.whoLeft}"><i class="fas fa-plus-circle fs-2"></i></button>`);
        $(`.party-invitation-state-label[steamid="${data.whoLeft}"]`).attr("data-i18n", "").text("");
    });        

    socket.on("party_name", async (data) => {
        console.log('party_name', data);
        $(".party-party-name").text(data);
    });

    ;
    
};

async function sendPartyChatMessage(msg) {
    if(sendingMsg) return;
    sendingMsg = true;
    let res = await KTAPI.sendChatToParty({message: msg});
    if(res.message == 'error') {
        console.log('Error al enviar el mensaje');
    }
    if(res.message == 'done') {
        console.log('Mensaje enviado');
        //renderPartyChat([res.chatMessage]);
    }
    sendingMsg = false;
}

function initPartyDrawer()
{
    $("#party_offscreen").append(partyDrawerHTML);
    if(partyDrawer != null) partyDrawer.destroy();
    partyDrawer = new KTDrawer($("#party-drawer")[0]);
    partyDrawer.on("kt.drawer.shown", function() {
        $("#party-chat-input").focus();
    });

    let partyDrawerChatScroll = new KTScroll($("#party-chat-container")[0], {});
}

function renderPartyChat(data) {
    let chatHtml = [];
    let lastSteamid = '';
    let parsedMsg = [];
    if(data.length == 0) return;
    if(data.length > 1) {
        data.forEach((msg) => {
            //chatHtml.push(renderChatMessage(msg));
            if(lastSteamid != msg.senderId.steamid) {       
                msg.message = `<p class="mb-1 text-gray-800">${msg.message}</p>`;
                parsedMsg.push(msg);
            }
            else {
                parsedMsg[parsedMsg.length - 1].message += `<p class="mb-1 text-gray-800">${msg.message}</p>`;
            }
            lastSteamid = msg.senderId.steamid;
        });
    }
    else {
        parsedMsg.push(data[0]);
    }

    parsedMsg.forEach((msg) => {
        
        //chatHtml.push();
        if($("#party-chat-container").find(".party-chat-chat-msg").last().attr("steamid") == msg.senderId.steamid) {
            $("#party-chat-container").find(".party-chat-chat-msg").last().find(".party-chat-msg-body").append(`<p class="mb-1 text-gray-800">${msg.message}</p>`);
        }
        else {
            $("#party-chat-container").append(renderChatMessage(msg));
        }
    });

    //$("#party-chat-container").append(chatHtml);
    $("#party-chat-container").scrollTop($("#party-chat-container")[0].scrollHeight);
    $("#party-drawer").localize();
    $("#party-drawer").find('[data-toggle="tooltip"]').tooltip();

    function renderChatMessage(msg) {
        let msgHtml = `<div class="d-flex mb-3 w-100 party-chat-chat-msg" _id="${msg._id}" steamid="${msg.senderId.steamid}">
                    <div class="d-flex align-items-start me-2">
                        <div class="symbol symbol-35px">
                            <img alt="Pic" src="${msg.senderId.avatar}">
                        </div>                    
                    </div>
                    <div class="d-flex flex-row-fluid flex-column align-items-start">
                        <div class="py-2 px-3 rounded bg-light-dark bg-opacity-75 text-start w-100 fw-normal">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <a href="user/${msg.senderId.communityid}" data-navigo="" class="fs-7 fw-bold text-truncate text-nowrap text-gray-900 mw-150px fnick"></a>
                                <span class="text-muted text-nowrap fs-8 align-self-end" data-i18n="example.date" data-i18n-options='{"timestamp":"${parseInt(msg.createdAt)+hostStampDif}"}'></span>
                            </div>
                            <div class="fs-7 fw-light party-chat-msg-body">${msg.message}</div>
                            </div>
                            
                    </div>`;
        msgHtml = $(msgHtml);
        msgHtml.find(".fnick").text(msg.senderId.nickname);
        msgHtml.find("[data-toggle=tooltip]").tooltip();
        msgHtml.localize();

        return msgHtml;
                
    };                    

}
        

function renderPartyDrawer(data) {
    if(data == null)
    {
        $("#party_offscreen").empty();
        initPartyDrawer();
        initHandlers();
        return;
    }

    if(data.imOwner) {
        //$(".party-party-leave-label").attr("data-i18n", "party.disband");        
        $("#party-drawer").data("imOwner", true);        
    }
    else {
        $("#party-drawer").data("imOwner", false);        
    }
    $("#party-drawer").data("ownerId", data.ownerId);
    $("#party-drawer").data("partyId", data._id);
    $("#party-drawer").data("partyName", data.partyName);

    data.membersInfo = data.membersInfo || {};
    data.membersStats = data.membersStats || {};

    let ratingAv = 0;
    Object.keys(data.membersStats).forEach((key) => {
        ratingAv += data.membersStats[key].rating;
    });
    ratingAv = ratingAv / Object.keys(data.membersStats).length;

    $(".party-party-rating").text(ratingAv);
    $(".party-party-name").text(data.partyName);

    let partyOwner = `
        <div class="position-relative symbol symbol-50px border-1 border-primary ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.ownerId}">
            <i class="fas fa-crown fs-7 text-zyellow position-absolute ms-auto me-auto start-0 end-0 text-center" style="top:-6px"></i>
            <img src="${data.membersInfo[data.ownerId].avatar === undefined ? "assets/media/avatars/default.jpg" : data.membersInfo[data.ownerId].avatar}" class="" alt="">
        </div>
    `;
    let partyMembers = '';

    for(let i = 0; i < data.maxMembers; i++) {
    //for(let i = data.maxMembers - 1; i >= 0; i--) {
        if(data.members[i] == data.ownerId) continue;
        if(data.members[i] != null && data.members[i] != undefined) {
            partyMembers += `
                <div class="position-relative symbol symbol-50px border-1 border-primary ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.members[i]} party-member">
                    <img src="${data.membersInfo[data.members[i]].avatar === undefined ? "assets/media/avatars/default.jpg" : data.membersInfo[data.members[i]].avatar}" class="" alt="">
                    ${data.imOwner ? `<span class="position-absolute btn btn-icon btn-circle btn-color-muted btn-active-color-danger w-20px h-20px bg-body shadow party-kick-member" style="top:-8px;right:-8px;" steamid="${data.members[i]}" data-bs-toggle="tooltip" data-bs-dismiss="click" data-i18n="[title]party.kickmember"><i class="bi bi-x fs-4"></i></span>` : ''}
                </div>
            `;
        }
        else {
            partyMembers += `
                <div class="symbol symbol-50px border-1 border-gray-400 cursor-pointer party-party-invite-list">
                    <span class="symbol-label bg-gray-200">
                        <i class="far fa-user-plus fs-4"></i>
                    </span>
                </div>
            `;
        }
    }

    $(".party-party-members").html(`${partyOwner}${partyMembers}`);

    if(data.imOwner) {
        $("#party-drawer").find(".owner-only").removeClass("d-none");
    }
    else {
        $("#party-drawer").find(".owner-only").addClass("d-none");
    }

    $("#party-drawer").localize();
    $("#party-drawer").find('[data-toggle="tooltip"]').tooltip();
}


async function leaveDlg() {
    if(onLeaving) return -1;
    onLeaving = true;

    let title = `<span class="" data-i18n="party.leave_dlg_title"></span>`;
    let content = $("#party-drawer").data("imOwner") == true ? `<p class="mb-1 text-gray-800" data-i18n="party.leave_dlg_content_creator"></p>` : `<p class="mb-1 text-gray-800" data-i18n="party.leave_dlg_content"></p>`;
    let accept = `<span class="" data-i18n="party.leave_dlg_accept"></span>`;
    let cancel = `<span class="" data-i18n="party.leave_dlg_cancel"></span>`;

    title = $(title).localize().text();
    content = $(content).localize().text();
    accept = $(accept).localize().text();
    cancel = $(cancel).localize().text();

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content,
            buttons: [{
                    text: cancel,
                    class: 'btn-secondary',
                    callback: function () {
                        resolve('cancel');
                    },
                    dismiss: true
                },
                {
                    text: accept,
                    class: 'btn btn-sm btn-danger btn-color-gray-200',
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },
            ],
            onHide: function () {
                onLeaving = false;
            },
            disableCloseButton: true,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}


async function errorDlg(error) {
  
    let title = `<span class="" data-i18n="error.party.error"></span>`;
    let content = `<p class="mb-1 text-gray-800" data-i18n="error.party.${error}"></p>`;
    let accept = `<span class="" data-i18n="error.party.close"></span>`;    

    title = $(title).localize().text();
    content = $(content).localize().text();
    accept = $(accept).localize().text();    

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content,
            buttons: [{
                    text: accept,
                    class: 'btn btn-sm btn-primary btn-text-gray-100 btn-active-light-primary btn-active-color-primary fw-bolder',
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },                
            ],
            onHide: function () {
                
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

async function invitationListDlg(data)
{  
    let title = `<span class="" data-i18n="party.invitelist_dlg_title"></span>`;    
    let cancel = `<span class="" data-i18n="party.invitelist_dlg_ok"></span>`;

    title = $(title).localize().text();
    cancel = $(cancel).localize().text();

    let content = ``;

    if(data == null) {
        
        
    }
    else
    {
        data.forEach((friend) => {
            let temp = `
                <div class="d-flex align-items-center justify-content-between bg-light-primary bg-opacity-25 rounded px-3 py-2 mb-2">
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px">
                            <img src="${friend.avatar}" class="" alt="">
                        </div>
                        <div class="d-flex flex-column ms-3">
                            <a href="user/${friend.communityid}" data-navigo="" class="fs-7 fw-bold text-gray-900 text-hover-primary text-truncate text-nowrap mw-150px fnick"></a>
                            <span class="fs-8 fw-normal text-gray-600" ${friend.inParty ? 'data-i18n="party.inparty"': ""}"></span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center party-invitation-state">
                        <button class="btn btn-sm btn-icon btn-color-primary btn-active-light btn-active-color-primary party-invite-friend" steamid="${friend.steamid}"><i class="fas fa-plus-circle fs-2"></i></button>
                    </div>
                </div>
            `;
            
            temp = $(temp);
            temp.find(".fnick").text(friend.nickname);
            temp.localize();
            content += temp[0].outerHTML;        
        });
        
    }

    content = `
        <div class="scroll-overflow mh-200px mh-lg-325px party-invite-friends-list">
            ${content}
        </div>
        `;


    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise(async (resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content,            
            onHide: function () {                
                resolve('ok');
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true,
            dialogClasses: 'modal-sm',
            bodyClasses: 'px-4'
        });

        dialog1.show();

        if(data == null) {
            let res = await KTAPI.getPartyFriendsForInvite();
            if(res.message == 'error') {
                console.log('Error al cargar la lista de amigos');
            }
            if(res.message == 'done') {
                let content = ``;
                res.friends.forEach((friend) => {
                    let temp = `
                        <div class="d-flex flex-stack px-4 py-3 bg-state-white bg-state-opacity-5 rounded ${friend.inParty == true || (friend.onInvitation == true && friend.invitationInfo[0].senderId !== _user.me.steamid) ? "opacity-50" : ""} party-invitation-container" steamid="${friend.steamid}">
                            <div class="d-flex align-items-center">
                                <div class="symbol symbol-35px">
                                    <img src="${friend.avatar}" class="" alt="">
                                </div>
                                <div class="d-flex flex-column ms-3 ">
                                    <a href="user/${friend.communityid}" data-navigo="" class="fs-7 fw-bold text-gray-900 text-hover-primary text-truncate text-nowrap mw-150px fnick"></a>
                                    <span class="fs-8 fw-normal text-gray-600 party-invitation-state-label" ${friend.inParty ? 'data-i18n="party.inparty"': ""} ${friend.onInvitation ? 'data-i18n="party.oninvite"': ""}" steamid="${friend.steamid}"></span>
                                </div>
                            </div>
                            <div class="d-flex align-items-center party-invitation-state" steamid="${friend.steamid}">
                                ${friend.onInvitation == true && friend.invitationInfo[0].senderId == _user.me.steamid ? `<button class="btn btn-sm btn-icon btn-color-info" steamid="${friend.steamid}"><span class="spinner-border spinner-border-sm align-middle border-3 h-20px w-20px"></span></button>` : `<button class="btn btn-sm btn-icon btn-color-primary btn-active-color-primary ${friend.inParty || friend.onInvitation ? "disabled" : "party-invite-friend"}" steamid="${friend.steamid}"><i class="fas fa-plus-circle fs-2"></i></button>`}
                                
                                
                            </div>
                        </div>
                    `;
                    console.log(_user.me.steamid, friend.invitationInfo);
                    temp = $(temp);
                    temp.find(".fnick").text(friend.nickname);
                    temp.localize();
                    content += temp[0].outerHTML;        
                });

                $(".party-invite-friends-list").html(content);
                router.updatePageLinks();
            }
        }
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'ok') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return true;
    }
    else {
        return false;
    }
}

async function invitationDlg(data)
{
    let title = `<span class="" data-i18n="party.invite_dlg_title"></span>`;
    
    let accept = `<span class="" data-i18n="party.invite_dlg_accept"></span>`;
    let cancel = `<span class="" data-i18n="party.invite_dlg_reject"></span>`;

    

    title = $(title).localize().text();
    
    accept = $(accept).localize().text();
    cancel = $(cancel).localize().text();

    let party = data.party;
    let invitation = data.invitation;
    
    let members = '';
    let ownerId = party.ownerId;
    for(let i = 0; i < party.maxMembers; i++) {
        if(party.members[i] == ownerId) continue;
        if(party.members[i] != null && party.members[i] != undefined) {
            members += `
                <div class="position-relative symbol symbol-35px border-1 border-primary popover-profile" data-steamid="${party.members[i]}">
                    <img src="${party.membersInfo[party.members[i]].avatar}" class="" alt="">
                </div>
            `;
        }
        else {
            members += `
                <div class="symbol symbol-35px border-1 border-gray-400">
                    <span class="symbol-label bg-gray-200">
                        <i class="far fa-user-clock fs-4"></i>
                    </span>
                </div>
            `;
        }
    }

    let content = `
        <div class="mb-2"><span class="text-white fw-bolder fnick"></span> <span class="" data-i18n="party.invite_dlg_hadinvitedyou"></span></div>

        <div class="d-flex flex-row w-100 align-items-center justify-content-between gap-1 px-4 py-3 bg-gray-100 rounded mb-2"> 
            <div class="position-relative symbol symbol-35px border-1 border-primary popover-profile" data-steamid="${party.ownerId}">
                <i class="fas fa-crown fs-7 text-zyellow position-absolute ms-auto me-auto start-0 end-0 text-center" style="top:-6px"></i>
                <img src="${party.membersInfo[ownerId].avatar}" class="" alt="">
            </div>
            ${members}
        </div>        
        <div class=""><span class="" data-i18n="party.invite_dlg_click"></span></div>
        <div class="d-flex align-items-center justify-content-center w-100 mt-4">
            <span class="text-muted fs-7 fw-normal"><span data-i18n="party.remaining_time"></span>: <span class="count-invite text-white"></span></span>
        </div>
    `;
    
    content = $("<div>").html(content);
    content.find(".fnick").text(party.membersInfo[invitation.senderId].nickname);
    content.localize();
    router.updatePageLinks();


    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content[0].outerHTML,
            buttons: [{
                    text: cancel,
                    class: `btn-secondary btn-sm party-decline-invitation invitation-${invitation._id}`,
                    callback: function () {
                        resolve('cancel');
                    },
                    dismiss: true
                },
                {
                    text: accept,
                    class: `btn btn-sm btn-primary btn-color-gray-200 party-accept-invitation invitation-${invitation._id}`,
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },
            ],
            onHide: function () {
                
            },
            onShow: function() {
                let count = new Countdown({
                    displayElement: '.count-invite',
                    seconds: 90,                    
                });
                count.start();
                router.updatePageLinks();
            },
            disableCloseButton: true,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true,
            autoHide: true,
            autoHideDelay: 90000
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

async function editPartyNameDlg()
{
    let title = `<span class="" data-i18n="party.editname_dlg_title"></span>`;
    let accept = `<span class="" data-i18n="party.editname_dlg_accept"></span>`;
    let cancel = `<span class="" data-i18n="party.editname_dlg_cancel"></span>`;

    let content = `<div class="input-group input-group-solid">
                    <input id="party-name-input" class="form-control fw-normal fs-6" placeholder="" data-i18n="[placeholder]party.partynameplaceholder"></input>
                    </div>`;

    title = $(title).localize().text();
    accept = $(accept).localize().text();
    cancel = $(cancel).localize().text();

    content = $(content).localize();

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content[0].outerHTML,
            buttons: [{
                    text: cancel,
                    class: 'btn-secondary',
                    callback: function () {
                        resolve('cancel');
                    },
                    dismiss: true
                },
                {
                    text: accept,
                    class: 'btn btn-sm btn-primary btn-color-gray-200',
                    callback: async function () {
                        if($("#party-name-input").val().length == 0) return;
                        if($("#party-name-input").val().length > 12) 
                        {
                            const $temp = $(`<div data-i18n="party.partynamelimit"></div>`);
                            $temp.localize();
                            const sanitizedHTML = $temp.text();
                            Toasted.showWarning(sanitizedHTML);
                            return;
                        }
                        let res = await KTAPI.editPartyName({partyName: $("#party-name-input").val()});
                        if(res.message == 'error') {
                            console.log('Error al cambiar el nombre del party');
                            if(res.error !== undefined) {
                                errorDlg(res.error);
                            }
                            dialog1.hide();
                        }
                        const $temp = $(`<div data-i18n="party.partynamechanged"></div>`);
                        $temp.localize();
                        const sanitizedHTML = $temp.text();
                        Toasted.showSuccess(sanitizedHTML);
                        resolve('accept');                        
                        dialog1.hide();
                    },
                    dismiss: false
                },
            ],
            onHide: function () {
                
            },
            onShow: function() {
                $("#party-name-input").val($("#party-drawer").data("partyName"));
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }

}


export { initPartySystem, partySocket };